import { combineReducers } from 'redux';

import select from './Select/reducer';

const rolesReducer = combineReducers({
  select,
});

export default rolesReducer;
